<script setup>
  import  {reactive, ref, computed} from 'vue';

  import StatInput from "../components/stat-jiggler/StatInput.vue";
  import StatHex from "../components/stat-jiggler/StatHex.vue";

  import BaseCard from "../components/BaseCard.vue";
  import ToolPageHeader from "../components/ToolPageHeader.vue";
  import InfoHover from "../components/InfoHover.vue";
  import PokemonSearch from "../components/PokemonSearch.vue";
  import PokemonIcon from "../components/PokemonIcon.vue";
  import InputGroup from "../components/InputGroup.vue";
  import CopyFormButton from "../components/CopyFormButton.vue";

  import POKEMON_DATA from '../data/pokemon-base-data.json';
  import { STATS, STAT_NAMES_SHORT } from '../components/stat-jiggler/constants.js';

  let pokemonDataKeysSortedByBST = [];
  for (let id in POKEMON_DATA) {
    pokemonDataKeysSortedByBST.push(id);
  }
  pokemonDataKeysSortedByBST.sort(function (a, b) {
    return POKEMON_DATA[a]['bst'] - POKEMON_DATA[b]['bst'];
  });

  // const statDiagramPadding = 16;

  const statDefaults = {
    'hp': 40,
    'atk': 40,
    'def': 40,
    'spatk': 40,
    'spdef': 40,
    'speed': 40,
    "bst": 240
}

  const stats = reactive({
    ...statDefaults
  })

  const bstLocked = ref(false)

  const sortedStats = computed(() => {
    //this sorts lowest-first and into ["hp", 50] tuples
    let sortable = [...STATS];
    // if (exclude) {
    //   sortable.splice(sortable.indexOf(exclude), 1);
    // }
    sortable.sort(() => (Math.random() > .5) ? 1 : -1);

    sortable.sort((a, b) => {
      if (stats[a] === stats[b]) {
        return Math.random() * 2 - 1;
      }
      return stats[a] - stats[b];
    });

    // if (highestFirst) {
      sortable = sortable.reverse();
    // }

    return sortable;
  });


  const statsAbsDifference = (stats, pokeKey)=>{
    let total = 0;
    ['hp','atk','def','spatk','spdef','speed'].forEach((stat)=>{
      total += Math.abs(stats[stat] - POKEMON_DATA[pokeKey].stats[stat]);
    })
    return total;
  }

  const closestMatch = computed(() => {
    let closestMatchKey = 0;

    if (stats.bst) {
      if (stats.bst <= POKEMON_DATA[pokemonDataKeysSortedByBST[0]]['bst']) {
        closestMatchKey = pokemonDataKeysSortedByBST[0];

      } else if (stats.bst >= POKEMON_DATA[pokemonDataKeysSortedByBST[pokemonDataKeysSortedByBST.length - 1]].bst) {
        closestMatchKey = pokemonDataKeysSortedByBST[pokemonDataKeysSortedByBST.length - 1];

      } else {

        let shortlist = [];

        for (let i in pokemonDataKeysSortedByBST) {
          if (i === 0) {
            continue;
          }
          let nextId = pokemonDataKeysSortedByBST[i];
          let prevId = pokemonDataKeysSortedByBST[i - 1];

          if (POKEMON_DATA[nextId]['bst'] >= stats.bst) {

            //let's see if we actually got a match first.
            shortlist.push(getClosestStatMatch(prevId, nextId, i));

          }

          if (POKEMON_DATA[nextId]['bst'] > stats.bst) {
            break
          }
        }
        let sortedShortlist = shortlist.sort((a,b)=>{
          return statsAbsDifference(stats, a) - statsAbsDifference(stats, b)
        })
        closestMatchKey = sortedShortlist[0];
      }
    }

    return POKEMON_DATA[closestMatchKey];
  })

  const evYields = computed(() => {
    //ev calc
    let evs = {
      0: [{
        stat: sortedStats.value[0],
        number: 1
      }],
      1: [{
        stat: sortedStats.value[0],
        number: 2
      }]
    }

    if (Math.abs(stats[sortedStats.value[0]] - stats[sortedStats.value[1]]) < 10) {
      evs[2] = [
        {
          stat: sortedStats.value[0],
          number: 2
        },
        {
          stat: sortedStats.value[1],
          number: 1
        }
      ];
    } else {
      evs[2] = [{
        stat : sortedStats.value[0],
        number: 3
      }];
    }

    return evs;
  });


  const setStats = (newStats)=>{
    for (let k in newStats){
      stats[k] = newStats[k];
    }
  }


  const sum = function(obj) {
    let sum = 0;
    for (let el in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, el)) {
        sum += parseFloat(obj[el]);
      }
    }
    return sum;
  };

  const sortStatsRandom = (exclude) => {
    let random_stat_order = [...STATS];
    if (exclude) {
      random_stat_order.splice(random_stat_order.indexOf(exclude), 1);
    }
    random_stat_order.sort(() => (Math.random() > .5) ? 1 : -1);
    return random_stat_order;
  };





  const setStatsFromPokemon = (pokemon, which) => {
    let newStats = {...pokemon.stats};

    if (which == 'bst'){
      //scale everything, then adjust random stats for the remainders.
      // mind out that this is backwards kind of - we're changing "this bst" into "pokemon bst" via the other stats.
      let mutiplier = pokemon.bst / stats.bst;

      newStats = {
        ...stats
      }
      delete newStats['bst'];


      for (let stat in newStats) {
        newStats[stat] = parseInt(Math.round(newStats[stat] * mutiplier));
      }

      let newBST = sum(newStats);


      if (newBST > pokemon.bst) {
        //we adjusted up, so drop the next highest stats
        //no - drop a random one
        let diff = newBST - pokemon.bst;
        for (let i = 0; i < diff; i++) {
          let randomStatOrder = sortStatsRandom(which);
          newStats[randomStatOrder[0]] -= 1;
        }

      } else {
        //we adjusted down, so raise the highest stats
        //no - raise a random one
        let diff = pokemon.bst - newBST;
        for (let i = 0; i < diff; i++) {
          let randomStatOrder = sortStatsRandom(which);
          newStats[randomStatOrder[0]] += 1;
        }
      }
    }

    newStats['bst'] = sum(newStats);

    setStats(newStats);
  };






  const setSingleStat = (stat, value) => {
    //update a stat to the given value, then prepare the stat list and bst and do setState

    if (value === "") {
      return;
    }

    let newStats = {
      ...stats
    }
    newStats[stat] = Math.max(Math.min(parseInt(value), 255), 1);
    delete newStats['bst'];
    let newBST = sum(newStats);

    if (bstLocked.value) {
      //adjust other stats down so the BST stays the same
      //adjust the highest stats (that aren't the one we just adjusted) down
      //or the lowest ones up.


      if (newBST > stats.bst) {
        //we adjusted up, so drop the next highest stats
        //no - drop a random one
        let diff = newBST - stats.bst;

        for (let i = 0; i < diff; i++) {
          let randomStatOrder = sortStatsRandom(stat);
          newStats[randomStatOrder[0]] -= 1;
        }

      } else {
        //we adjusted down, so raise the highest stats
        //no - raise a random one
        let diff = stats.bst - newBST;
        for (let i = 0; i < diff; i++) {
          let randomStatOrder = sortStatsRandom(stat);
          newStats[randomStatOrder[0]] += 1;
        }
      }

      newBST = stats.bst;

      //if any of the stats went out of bounds, cancel the whole op!
      for (let st in newStats) {
        if (newStats[st] < 1 || newStats[st] > 255) {
          return;
        }
      }

    }

    // console.log("stat update", stat, newStats)
    newStats.bst = newBST

    setStats(newStats)
  }


  const adjustAllStats = (diff) => {

    let newStats = {
      ...stats
    }
    delete newStats['bst'];
    for (let stat in newStats) {
      newStats[stat] = Math.max(Math.min(parseInt(newStats[stat] + diff), 255), 1);
    }
    let newBST = sum(newStats);

    newStats.bst = newBST
    setStats(newStats);
  };


  const jiggle = () => {
    //adjust all stats up or down by 5, optionally maintaining bst
    //also, do a jiggle effect w/ css animation

    //thoughts on maintaining bst:
    //basically all the jiggles should add up to 0, could pick a random stat to make up for the others.
    // or if it's <>5 then adjust another random stat
    // the point being, assign the adjustments at random so it's not always speed picking up the slack

    //coult we just assign 1,1,2,2,3,3..? we just need to pair them with negatives
    // so generate 3 randos and give other stats the negatives?
    // bc ther will be combinations that dont add up to 6 anyway.

    let newStats = {
      ...stats
    }
    delete newStats['bst'];

    if (bstLocked.value) {
      let rands = [];
      for (let i = 0; i < 3; i++) {
        let n = parseInt(Math.round(Math.random() * 10 - 5));
        rands.push(n)
        rands.push(-n)
      }
      let random_stat_order = sortStatsRandom();

      //we'll only make the paired adjustments if they wont push us out of bounds.
      // since the paris cancel out, ignoring them will keep us at the same bst!
      for (let s = 0; s < 6; s += 2) {
        let res1 = newStats[random_stat_order[s]] + rands[s];
        let res2 = newStats[random_stat_order[s + 1]] + rands[s + 1];

        if (res1 > 1 && res1 < 255 && res2 > 1 && res2 < 255) {
          newStats[random_stat_order[s]] = res1;
          newStats[random_stat_order[s + 1]] = res2;
        }
      }

    } else {
      for (let s in STATS) {
        newStats[STATS[s]] += parseInt(Math.round(Math.random() * 10 - 5));
        newStats[STATS[s]] = Math.max(Math.min(parseInt(newStats[STATS[s]]), 255), 1);
      }
    }

    let newBST = sum(newStats);
    newStats['bst'] = newBST;

    // console.log("stat update", stat, newStats)

    //for each jiggleable item, add a random class out of jiggle1 - jiggle4
    let jigglerClasses = [".stat-distribution",".jiggle-button"];
    for(let s in STATS){
      jigglerClasses.push('.stat-input-'+STATS[s]);
    }
    if (!bstLocked.value){
      jigglerClasses.push('.bstlock-button')
      jigglerClasses.push('.stat-input-bst');
    }
    let jigglers = document.querySelectorAll(jigglerClasses.join(", "));
    // console.log(jigglers)
    jigglers.forEach(function (jiggler) {
      // console.log(jiggler)
      jiggler.classList.add("jiggle" + parseInt(Math.floor(Math.random() * 4 + 1)));
    })
    window.setTimeout(function () {
      jigglers.forEach(function (jiggler) {
        jiggler.classList.remove("jiggle1");
        jiggler.classList.remove("jiggle2");
        jiggler.classList.remove("jiggle3");
        jiggler.classList.remove("jiggle4");
      })
    }, 500)


    setStats(newStats);
  };







  const getClosestStatMatch = (prevId, nextId, i) => {

    if (POKEMON_DATA[nextId]['bst'] === stats.bst) {

      //so we stop at the first match, but we can keep going until the BST is wrong and see if we get any full stat matches
      let counts_to_ids = {};
      let j = 0;
      while (j < POKEMON_DATA.length) {

        let testId = pokemonDataKeysSortedByBST["" + (parseInt(i) + j)];

        if (POKEMON_DATA[testId] === undefined || POKEMON_DATA[testId]['bst'] > stats.bst) {
          //nah, overshot
          break;

        } else {
          let count = 0;
          for (let s in STATS) {
            if (POKEMON_DATA[testId].stats[STATS[s]] === stats[STATS[s]]) {
              count++;
            }
          }
          if (counts_to_ids[count] === undefined) {
            counts_to_ids[count] = []
          }
          counts_to_ids[count].push(testId);
        }

        j++;
      }


      for (let k = 6; k > 0; k--) {
        if (counts_to_ids[k] !== undefined && counts_to_ids[k].length) {
          return counts_to_ids[k][0];
        }
      }

    } else {

      //are we nearer to the next one or the prev one?
      if (
        Math.abs(POKEMON_DATA[nextId]['bst'] - stats.bst)
        <
        Math.abs(POKEMON_DATA[prevId]['bst'] - stats.bst)
      ) {
        return nextId;
      } else {
        return prevId;
      }

    }

    return nextId;
  };
</script>

<template>
  <div class="container mt-8 mb-20">
    <ToolPageHeader tool="stat-jiggler">
      <template #info>
        <p class="my-2">Click the {{closestMatch ? closestMatch.name : 'Closest Match button'}} and use the search box to find a Pokémon to start with. Then adjust and jiggle the stats to make them unique.</p>
        <p class="my-2">You can also drag out the handles on the diagram. Hold shift while dragging to scale the whole thing.</p>
        <p class="my-2">Suggested EVs will also be generated, as they are usually linked to stat distribution and evolution stage.</p>
      </template>
      <template #controls>
        <CopyFormButton tool="stat-jiggler" :form="stats" :form-defaults="statDefaults" :form-mutator="setSingleStat"/>
      </template>
    </ToolPageHeader>


    <div class="my-12 flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">

      <BaseCard tool="stat-jiggler" class="lg:col-span-2 ">

        <StatHex
          :stats="stats"
          :padding="16"
          :bstLocked="bstLocked"
          :adjustAllStats="adjustAllStats"
          :setSingleStat="setSingleStat"
        />

      </BaseCard>

      <div class="flex flex-col gap-8">
        <BaseCard tool="stat-jiggler" class="flex flex-col gap-8">

          <StatInput stat="bst" :value="stats.bst" :readonly="true"/>

          <InputGroup :vertical="true">
            <template #label>Closest match:</template>
            <template #input>
              <PokemonSearch @select="setStatsFromPokemon">
                <template #chosen>
                  <div class="flex items-center gap-4">
                    <PokemonIcon :pokemon="closestMatch"/>
                    <div class="grow">
                      <div class="inline-block font-bold text-lg">{{closestMatch?.name}} ({{ closestMatch?.bst }})</div>
                    </div>
                  </div>
                </template>
                <template #controls="controlsProps">
                  <div class="button button-sm bg-tool-stat-jiggler/90 text-white hover:bg-tool-stat-jiggler/75" @click="controlsProps.select(controlsProps.pokemon, 'bst')">
                    Use BST
                  </div>
                  <div class="button button-sm bg-tool-stat-jiggler text-white hover:bg-tool-stat-jiggler/75" @click="controlsProps.select(controlsProps.pokemon, 'all')">
                    Use All
                  </div>
                </template>
              </PokemonSearch>
            </template>
          </InputGroup>

          <div class="flex flex-col gap-2">
            <StatInput stat="hp" :value="stats.hp" :set-single-stat="setSingleStat"/>
            <StatInput stat="atk" :value="stats.atk" :set-single-stat="setSingleStat"/>
            <StatInput stat="def" :value="stats.def" :set-single-stat="setSingleStat"/>
            <StatInput stat="spatk" :value="stats.spatk" :set-single-stat="setSingleStat"/>
            <StatInput stat="spdef" :value="stats.spdef" :set-single-stat="setSingleStat"/>
            <StatInput stat="speed" :value="stats.speed" :set-single-stat="setSingleStat"/>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div
              class="bstlock-button button bg-tool-stat-jiggler text-white hover:bg-tool-stat-jiggler/75 !flex gap-2 justify-stretch items-center !px-2"
              @click="bstLocked = !bstLocked"
            >
              <img
                :src="$router.options.base + (
                  bstLocked
                    ? '/images/stat-jiggler/stathex-locked.svg'
                    : '/images/stat-jiggler/stathex-unlocked.svg'
                  )"
                :alt="'Diagram showing BST is ' + (bstLocked ? 'locked' : 'unlocked')"
                class="max-w-[2rem]"
              />
              <div class="grow text-center">{{bstLocked ? 'Unlock BST' : 'Lock BST'}}</div>
            </div>


            <div
              class="jiggle-button button bg-tool-stat-jiggler text-white hover:bg-tool-stat-jiggler/75 !flex gap-2 justify-stretch items-center !px-2"
              @click="jiggle()"
            >
              <img
                :src="$router.options.base+'/images/stat-jiggler/stathex-jiggle.svg'"
                alt="An irregular stat hex"
                class="max-w-[2rem]"
              />
              <div class="grow text-center">
                <InfoHover text="Randomly adjust all stats a little"/>
                Jiggle
              </div>
            </div>

          </div>

        </BaseCard>


        <BaseCard tool="stat-jiggler" class="flex flex-col gap-8">

          <table class="styled-table">
            <thead>
              <tr>
                <th colspan="2">Suggested EV Yield:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Basic</td>
                <td>
                  <div
                    v-for="(ev,i) in evYields[0]"
                    :key="i"
                    :class="'inline-flex mr-2 rounded-lg border-4 border-stat-'+ev.stat+' text-white text-sm'"
                  >
                    <div :class="'pl-1 bg-stat-'+ev.stat+' pr-2'">{{STAT_NAMES_SHORT[ev.stat]}}</div>
                    <div :class="'text-black dark:text-white px-1 rounded-lg border-4 border-stat-'+ev.stat+' m-[-4px]'">{{ ev.number }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Stage 1</td>
                <td>
                  <div
                    v-for="(ev,i) in evYields[1]"
                    :key="i"
                    :class="'inline-flex mr-2 rounded-lg border-4 border-stat-'+ev.stat+' text-white text-sm'"
                  >
                    <div :class="'pl-1 bg-stat-'+ev.stat+' pr-2'">{{STAT_NAMES_SHORT[ev.stat]}}</div>
                    <div :class="'text-black dark:text-white px-1 rounded-lg border-4 border-stat-'+ev.stat+' m-[-4px]'">{{ ev.number }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Stage 2 </td>
                <td>
                  <div
                    v-for="(ev,i) in evYields[2]"
                    :key="i"
                    :class="'inline-flex mr-2 rounded-lg border-4 border-stat-'+ev.stat+' text-white text-sm'"
                  >
                    <div :class="'pl-1 bg-stat-'+ev.stat+' pr-2'">{{STAT_NAMES_SHORT[ev.stat]}}</div>
                    <div :class="'text-black dark:text-white px-1 rounded-lg border-4 border-stat-'+ev.stat+' m-[-4px]'">{{ ev.number }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        </BaseCard>

      </div>


    </div>

  </div>
</template>
